import { createElement } from "react";
import React from "react";
import { useCtx } from "../Context.jsx";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { S3UploadFile, NewTask, NewCourse } from "../Shared/SharedModels.jsx";
import { Spinner, DialogActions, Image, Checkbox, Button, tokens, Caption2, Caption1, CardHeader, Card, Text as Text$, Textarea, Input, Field, DialogContent, Subtitle1, DialogTitle, DialogBody, DialogSurface, DialogTrigger, Dialog } from "@fluentui/react-components";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { take, length, tryHead, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { ImageAddRegular, AddRegular, ClipboardTaskAddRegular, DismissRegular, CheckmarkCircleRegular, CheckmarkLockRegular } from "@fluentui/react-icons";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { append as append_1, map } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { Checkbox_toBool } from "../fable_modules/FS.FluentUI.2.5.2/Domain.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { startAsPromise } from "../fable_modules/fable-library-js.4.24.0/Async.js";
import { Browser_Types_File__File_ReadAsByteArray } from "../fable_modules/Fable.Remoting.Client.7.35.0/Extensions.fs.js";
import { toastServerError, Course } from "../ApiClient.jsx";
import { successToast, errorToast } from "../Toasts.jsx";

export function CreateCourseDialog(createCourseDialogInputProps) {
    let elems_19, el, el_106, elems_18, el_104, elems_17, el_4, el_2, el_90, elems_14, el_9, el_14, el_19, elems_11, elems_13, el_102, elems_16, el_94, el_92, el_100, elems_15, elemsToUse;
    const callback = createCourseDialogInputProps.callback;
    const trigger = createCourseDialogInputProps.trigger;
    const setCtx = useCtx()[1];
    const patternInput_1 = reactApi.useState(false);
    const setIsOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const patternInput_3 = reactApi.useState(false);
    const patternInput_4 = reactApi.useState(false);
    const patternInput_5 = reactApi.useState(undefined);
    const setFile = patternInput_5[1];
    const file = patternInput_5[0];
    const patternInput_6 = reactApi.useState(undefined);
    const setImg = patternInput_6[1];
    const img = patternInput_6[0];
    const patternInput_7 = reactApi.useState(undefined);
    const setAddTask = patternInput_7[1];
    const addTask = patternInput_7[0];
    const patternInput_8 = reactApi.useState(false);
    const setIsSending = patternInput_8[1];
    const isSending = patternInput_8[0];
    const defaultCourseEmpty = new NewCourse("", "", "", [], undefined);
    const defaultTaskInitializer = new NewTask("Oppmøte", "Må møte opp på kurset", true);
    const patternInput_9 = reactApi.useState(defaultTaskInitializer);
    const defaultTask = patternInput_9[0];
    const patternInput_10 = reactApi.useState(defaultCourseEmpty);
    const setNewCourse = patternInput_10[1];
    const newCourse = patternInput_10[0];
    const resetState = () => {
        setNewCourse(defaultCourseEmpty);
        setIsSending(false);
        setAddTask(undefined);
        setImg(undefined);
        setFile(undefined);
    };
    const el_108 = Dialog;
    return createElement(el_108, createObj(ofArray([["onOpenChange", (_arg, value_1) => {
        setIsOpen(value_1.open);
    }], ["open", patternInput_1[0]], (elems_19 = [(el = DialogTrigger, createElement(el, {
        children: trigger,
    })), (el_106 = DialogSurface, createElement(el_106, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        maxWidth: 700,
    }], (elems_18 = [(el_104 = DialogBody, createElement(el_104, createObj(ofArray([["style", {
        minHeight: 40 + "vh",
    }], (elems_17 = [(el_4 = DialogTitle, createElement(el_4, {
        children: (el_2 = Subtitle1, createElement(el_2, {
            children: "Ny kursmal",
        })),
    })), (el_90 = DialogContent, createElement(el_90, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 15 + "px ",
    }], (elems_14 = [(el_9 = Field, createElement(el_9, createObj(toList(delay(() => append(singleton(["required", true]), delay(() => append(singleton(["label", "Navn"]), delay(() => append(patternInput_2[0] ? append(singleton(["validationMessage", "Navn kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
        let matchValue, el_6;
        return singleton(["children", (matchValue = tryHead([(el_6 = Input, createElement(el_6, {
            appearance: "filled-darker",
            type: "text",
            value: newCourse.Name,
            onChange: (_arg_1, value_1_8) => {
                const v = value_1_8;
                setNewCourse(new NewCourse(v.value, newCourse.Summary, newCourse.Description, newCourse.Tasks, newCourse.Image));
                patternInput_9[1](new NewTask(`Oppmøte ${v.value}`, defaultTask.Description, defaultTask.VerificationRequired));
                patternInput_2[1](isNullOrWhiteSpace(v.value));
            },
        }))]), (matchValue == null) ? defaultOf() : matchValue)]);
    }))))))))))), (el_14 = Field, createElement(el_14, createObj(toList(delay(() => append(singleton(["required", true]), delay(() => append(singleton(["label", "Oppsummering"]), delay(() => append(patternInput_3[0] ? append(singleton(["validationMessage", "Oppsummering kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
        let matchValue_1, el_11;
        return singleton(["children", (matchValue_1 = tryHead([(el_11 = Textarea, createElement(el_11, {
            appearance: "filled-darker",
            value: newCourse.Summary,
            onChange: (_arg_2, value_1_13) => {
                const v_1 = value_1_13;
                setNewCourse(new NewCourse(newCourse.Name, v_1.value, newCourse.Description, newCourse.Tasks, newCourse.Image));
                patternInput_3[1](isNullOrWhiteSpace(v_1.value));
            },
        }))]), (matchValue_1 == null) ? defaultOf() : matchValue_1)]);
    }))))))))))), (el_19 = Field, createElement(el_19, createObj(toList(delay(() => append(singleton(["label", "Beskrivelse"]), delay(() => append(patternInput_4[0] ? append(singleton(["validationMessage", "Beskrivelse kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
        let matchValue_2, el_16;
        return singleton(["children", (matchValue_2 = tryHead([(el_16 = Textarea, createElement(el_16, {
            style: {
                minHeight: 100,
            },
            resize: "vertical",
            appearance: "filled-darker",
            value: newCourse.Description,
            onChange: (_arg_3, value_1_17) => {
                const v_2 = value_1_17;
                setNewCourse(new NewCourse(newCourse.Name, newCourse.Summary, v_2.value, newCourse.Tasks, newCourse.Image));
                patternInput_4[1](isNullOrWhiteSpace(v_2.value));
            },
        }))]), (matchValue_2 == null) ? defaultOf() : matchValue_2)]);
    }))))))))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 5 + "px ",
    }], (elems_11 = toList(delay(() => {
        let el_21;
        return append(singleton((el_21 = Text$, createElement(el_21, {
            children: "Oppgaver",
        }))), delay(() => {
            let el_33, elems_3, el_31, el_23, el_25, el_27, el_29;
            return append(singleton((el_33 = Card, createElement(el_33, createObj(ofArray([["size", "small"], ["appearance", "filled-alternative"], (elems_3 = [(el_31 = CardHeader, createElement(el_31, {
                header: (el_23 = Caption1, createElement(el_23, {
                    children: defaultTask.Name,
                })),
                description: (el_25 = Caption2, createElement(el_25, {
                    children: defaultTask.Description,
                })),
                image: defaultTask.VerificationRequired ? ((el_27 = CheckmarkLockRegular, createElement(el_27, {
                    fontSize: 20,
                    primaryFill: tokens.colorStatusSuccessForeground1,
                }))) : ((el_29 = CheckmarkCircleRegular, createElement(el_29, {
                    fontSize: 20,
                    primaryFill: tokens.colorStatusSuccessForeground1,
                }))),
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))), delay(() => append(map((task) => {
                let elems_4, el_47, el_35, el_37, el_39, el_41, el_45, el_43;
                const el_49 = Card;
                return createElement(el_49, createObj(ofArray([["size", "small"], ["appearance", "filled-alternative"], (elems_4 = [(el_47 = CardHeader, createElement(el_47, {
                    header: (el_35 = Caption1, createElement(el_35, {
                        children: task.Name,
                    })),
                    description: (el_37 = Caption2, createElement(el_37, {
                        children: task.Description,
                    })),
                    image: task.VerificationRequired ? ((el_39 = CheckmarkLockRegular, createElement(el_39, {
                        fontSize: 20,
                        primaryFill: tokens.colorStatusSuccessForeground1,
                    }))) : ((el_41 = CheckmarkCircleRegular, createElement(el_41, {
                        fontSize: 20,
                        primaryFill: tokens.colorStatusSuccessForeground1,
                    }))),
                    action: (el_45 = Button, createElement(el_45, {
                        onClick: (_arg_4) => {
                            setNewCourse(new NewCourse(newCourse.Name, newCourse.Summary, newCourse.Description, newCourse.Tasks.filter((t) => (t.Name !== task.Name)), newCourse.Image));
                        },
                        appearance: "transparent",
                        style: {
                            padding: 0,
                            borderWidth: 0,
                        },
                        icon: (el_43 = DismissRegular, createElement(el_43, {
                            style: {
                                padding: 0,
                            },
                            fontSize: 16,
                        })),
                    })),
                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])])));
            }, newCourse.Tasks), delay(() => {
                let elems_10, el_80, elems_9, el_78, elems_7, elems_5, el_55, el_57, el_64, el_66, el_68, elems_8, el_72, el_70, el_76, el_74, children, el_53, el_51;
                const matchValue_3 = addTask;
                if (matchValue_3 != null) {
                    const task_1 = matchValue_3;
                    return singleton(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        gap: 5 + "px ",
                    }], (elems_10 = [(el_80 = Card, createElement(el_80, createObj(ofArray([["style", {
                        flexGrow: 1,
                    }], ["size", "small"], ["appearance", "filled-alternative"], (elems_9 = [(el_78 = CardHeader, createElement(el_78, {
                        header: createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            flexDirection: "column",
                            flexGrow: 1,
                        }], (elems_7 = [createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            flexGrow: 1,
                            gap: 5 + "px ",
                        }], (elems_5 = [(el_55 = Input, createElement(el_55, {
                            placeholder: "Navn",
                            onChange: (_arg_6, value_1_33) => {
                                setAddTask(new NewTask(value_1_33.value, task_1.Description, task_1.VerificationRequired));
                            },
                            size: "medium",
                            appearance: "filled-darker",
                        })), (el_57 = Input, createElement(el_57, {
                            style: {
                                display: "flex",
                                flexGrow: 1,
                            },
                            size: "medium",
                            appearance: "filled-darker",
                            placeholder: "Beskrivelse",
                            onChange: (_arg_7, value_1_35) => {
                                setAddTask(new NewTask(task_1.Name, value_1_35.value, task_1.VerificationRequired));
                            },
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), (el_64 = Field, createElement(el_64, createObj(toList(delay(() => append((newCourse.Tasks.some((t_1) => (t_1.Name.toLocaleLowerCase() === task_1.Name.toLocaleLowerCase())) ? true : (task_1.Name.toLocaleLowerCase() === defaultTask.Name.toLocaleLowerCase())) ? singleton(["validationMessage", "Navn må være unikt"]) : empty(), delay(() => {
                            let matchValue_4, el_61, el_59;
                            return singleton(["children", (matchValue_4 = tryHead([(el_61 = Checkbox, createElement(el_61, {
                                labelPosition: "after",
                                label: (el_59 = Caption2, createElement(el_59, {
                                    children: "Godkjennes av kursholder",
                                })),
                                checked: task_1.VerificationRequired,
                                onChange: (_arg_8, c) => {
                                    setAddTask(new NewTask(task_1.Name, task_1.Description, Checkbox_toBool(c)));
                                },
                            }))]), (matchValue_4 == null) ? defaultOf() : matchValue_4)]);
                        })))))))], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))),
                        image: task_1.VerificationRequired ? ((el_66 = CheckmarkLockRegular, createElement(el_66, {
                            fontSize: 28,
                        }))) : ((el_68 = CheckmarkCircleRegular, createElement(el_68, {
                            fontSize: 28,
                        }))),
                        action: createElement("div", createObj(singleton_1((elems_8 = [(el_72 = Button, createElement(el_72, {
                            onClick: (_arg_9) => {
                                setAddTask(undefined);
                            },
                            appearance: "transparent",
                            style: {
                                padding: 0,
                                borderWidth: 0,
                            },
                            icon: (el_70 = DismissRegular, createElement(el_70, {
                                style: {
                                    padding: 0,
                                },
                                fontSize: 16,
                            })),
                        })), (el_76 = Button, createElement(el_76, {
                            disabled: ((isNullOrWhiteSpace(task_1.Name) ? true : isNullOrWhiteSpace(task_1.Description)) ? true : newCourse.Tasks.some((t_2) => (t_2.Name.toLocaleLowerCase() === task_1.Name.toLocaleLowerCase()))) ? true : (task_1.Name.toLocaleLowerCase() === defaultTask.Name.toLocaleLowerCase()),
                            onClick: (_arg_10) => {
                                setNewCourse(new NewCourse(newCourse.Name, newCourse.Summary, newCourse.Description, append_1([task_1], newCourse.Tasks), newCourse.Image));
                                setAddTask(undefined);
                            },
                            appearance: "transparent",
                            icon: (el_74 = ClipboardTaskAddRegular, createElement(el_74, {})),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_8))])))),
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_9))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))));
                }
                else {
                    return singleton((children = singleton_1((el_53 = Button, createElement(el_53, {
                        size: "small",
                        appearance: "transparent",
                        children: "Legg til oppgave",
                        icon: (el_51 = AddRegular, createElement(el_51, {})),
                        onClick: (_arg_5) => {
                            setAddTask(new NewTask("", "", false));
                        },
                    }))), createElement("div", {
                        children: reactApi.Children.toArray(Array.from(children)),
                    })));
                }
            }))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_11))])]))), createElement("input", {
        id: "image-select-input",
        type: "file",
        accept: "image/png, image/jpeg",
        onChange: (ev) => {
            const files = ev.target.files;
            if (!(files == null) && (files.length > 0)) {
                const f = files.item(0);
                const reader = new FileReader();
                reader.onload = ((_arg_11) => {
                    const matchValue_5 = reader.result;
                    if (typeof matchValue_5 === "string") {
                        const base64data = matchValue_5;
                        setFile(f);
                        setImg(base64data);
                    }
                });
                reader.readAsDataURL(f);
            }
        },
        style: {
            display: "none",
        },
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
    }], (elems_13 = toList(delay(() => {
        let i, el_82, el_88, elems_12, el_86;
        return (file != null) ? ((img != null) ? ((i = img, append(singleton((el_82 = Image, createElement(el_82, {
            style: {
                width: 95 + "%",
                maxWidth: 400,
                maxHeight: 250,
                minHeight: 150,
            },
            fit: "contain",
            src: i,
        }))), delay(() => {
            let el_84;
            return singleton((el_84 = Button, createElement(el_84, {
                children: "Slett",
                size: "small",
                onClick: (_arg_12) => {
                    setFile(undefined);
                    setImg(undefined);
                },
                appearance: "transparent",
            })));
        })))) : singleton((el_88 = Button, createElement(el_88, createObj(ofArray([["onClick", (_arg_13) => {
            document.getElementById("image-select-input").click();
        }], ["style", {
            width: 95 + "%",
            maxWidth: 400,
            maxHeight: 250,
            minHeight: 150,
            borderStyle: "dashed",
            borderColor: tokens.colorBrandBackgroundStatic,
            borderWidth: 1,
        }], (elems_12 = [(el_86 = ImageAddRegular, createElement(el_86, {
            fontSize: 48,
            primaryFill: tokens.colorBrandForeground2,
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_12))])])))))) : singleton((el_88 = Button, createElement(el_88, createObj(ofArray([["onClick", (_arg_13) => {
            document.getElementById("image-select-input").click();
        }], ["style", {
            width: 95 + "%",
            maxWidth: 400,
            maxHeight: 250,
            minHeight: 150,
            borderStyle: "dashed",
            borderColor: tokens.colorBrandBackgroundStatic,
            borderWidth: 1,
        }], (elems_12 = [(el_86 = ImageAddRegular, createElement(el_86, {
            fontSize: 48,
            primaryFill: tokens.colorBrandForeground2,
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_12))])])))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_13))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_14))])])))), (el_102 = DialogActions, createElement(el_102, createObj(ofArray([["position", "end"], (elems_16 = [(el_94 = DialogTrigger, createElement(el_94, {
        disableButtonEnhancement: true,
        children: (el_92 = Button, createElement(el_92, {
            disabled: isSending,
            appearance: "secondary",
            children: "Avbryt",
            onClick: (_arg_14) => {
                resetState();
            },
        })),
    })), (el_100 = Button, createElement(el_100, createObj(ofArray([["disabled", ((isNullOrWhiteSpace(newCourse.Name) ? true : isNullOrWhiteSpace(newCourse.Summary)) ? true : isSending) ? true : (addTask != null)], ["appearance", "primary"], ["onClick", (_arg_15) => {
        setIsSending(true);
        const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let file_1;
            return ((file_1 = file, PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                if (file_1 != null) {
                    const f_1 = file_1;
                    return startAsPromise(Browser_Types_File__File_ReadAsByteArray(f_1)).then((_arg_16) => {
                        let res;
                        const MimeType = f_1.type;
                        res = (new S3UploadFile(f_1.name, MimeType, _arg_16));
                        return Promise.resolve(res);
                    });
                }
                else {
                    return Promise.resolve(undefined);
                }
            })))).then((_arg_17) => {
                let pr_1;
                const pr = startAsPromise(Course.AddCourse(new NewCourse(newCourse.Name, newCourse.Summary, newCourse.Description, append_1([defaultTask], newCourse.Tasks), _arg_17)));
                pr_1 = (pr.then((res_1) => {
                    if (res_1.tag === 1) {
                        if (res_1.fields[0].tag === 1) {
                            errorToast(setCtx, "addCourseErrorUploadImageError", "Kunne ikke opprette kursmal", "Kunne ikke behandle bildet", undefined);
                            setIsSending(false);
                        }
                        else {
                            errorToast(setCtx, "addCourseErrorConflict", "Kunne ikke opprette kursmal", "Det fins kursmaler med samme navn", undefined);
                            setIsSending(false);
                        }
                    }
                    else {
                        const createdCourse = res_1.fields[0];
                        successToast(setCtx, `addCourse${createdCourse.Id}Success`, "Kursmal opprettet", `Kursmal ${createdCourse.Name} ble opprettet`);
                        resetState();
                        callback(createdCourse);
                        setIsOpen(false);
                    }
                }));
                void (pr_1.catch((ex) => {
                    setIsSending(false);
                    toastServerError(setCtx, ex);
                }));
                return Promise.resolve();
            });
        }));
        void pr_2;
    }], (elems_15 = toList(delay(() => {
        let el_96, el_98;
        return isSending ? singleton((el_96 = Spinner, createElement(el_96, {
            size: "tiny",
        }))) : singleton((el_98 = Text$, createElement(el_98, {
            children: "Lagre",
        })));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_15))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_16))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_17))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_18))])]))))], (elemsToUse = ((length(elems_19) <= 2) ? elems_19 : take(2, elems_19)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

//# sourceMappingURL=CreateCourse.jsx.map
